import { IContact } from '../interfaces';

export interface IContactState {
    contacts: IContact[];
}

export const initialContactsState: IContactState = {
    contacts: undefined,
};
